/**
 * Enum that describes the available comparaison type
 */
export enum ComparatorType {
    eq = 'eq',
    neq = 'neq',
    gt = 'gt',
    lt = 'lt'
}